// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!../fonts/fonts.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.player-scrollbar {
  scrollbar-color: var(--primaryColor) transparent;
  scrollbar-width: thin;
}

.player-scrollbar::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.player-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: var(--primaryColor);
}

.player-scrollbar::-webkit-scrollbar-corner,
.player-scrollbar::-webkit-scrollbar-track {
  background: none;
}

.common_button__8\\+QIM {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;

  position: relative;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;
  padding: 0;
  border: none;

  font: inherit;
  color: inherit;

  background: none;
  outline: none;
}

.common_button__8\\+QIM svg {
  pointer-events: none;
  color: var(--overlayForeground);
  fill: var(--overlayForeground);
}

.common_button__8\\+QIM:focus-visible {
  outline: 2px solid var(--primaryColor);
}

.common_button__8\\+QIM::after {
  content: '';

  position: absolute;
  bottom: -7px;

  display: block;

  width: 0;
  height: 3px;

  opacity: 0;
  background: var(--primaryColor);

  transition-duration: 0.1s, 0.2s;
  transition-property: width, opacity;
}

.common_button__8\\+QIM.common_active__cfwZT::after {
  width: 100%;
  opacity: 1;
}

.common_rangeInput__jNn0g {
  height: var(--track-height);
  margin: 0;
  appearance: none;

  -webkit-tap-highlight-color: transparent;
}

.common_rangeInput__jNn0g:focus {
  outline: none;
}

/* -- Track -- */

/* Chrome, Safari, Opera */
.common_rangeInput__jNn0g::-webkit-slider-runnable-track {
  cursor: pointer;
  border-radius: 2px;
}

/* Firefox */
.common_rangeInput__jNn0g::-moz-range-track {
  cursor: pointer;
}

/* -- Thumb -- */

/* Chrome, Safari, Opera */
.common_rangeInput__jNn0g::-webkit-slider-thumb {
  cursor: pointer;

  z-index: 100;

  width: var(--thumb-size);
  height: var(--thumb-size);
  border: none;
  border-radius: 50%;

  -webkit-appearance: none;
  background: var(--overlayForeground);
}

.common_rangeInput__jNn0g:focus-visible::-webkit-slider-thumb {
  outline: 2px solid var(--primaryColor);
}

.common_rangeInput__jNn0g.common_animated__NumCc::-webkit-slider-thumb {
  transform: scale(0);

  opacity: 0;

  -webkit-transition: opacity, transform;

  transition: opacity, transform;
  transition-timing-function: ease-in-out;
  transition-duration: 0.2s;
}

.common_rangeInput__jNn0g.common_animated__NumCc:hover::-webkit-slider-thumb {
  transform: scale(1);
  opacity: 1;
}

.common_rangeInput__jNn0g.common_animated__NumCc:focus-visible::-webkit-slider-thumb {
  transform: scale(1);
  opacity: 1;
}

@media (prefers-reduced-motion) {
  .common_rangeInput__jNn0g.common_animated__NumCc::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}

/* Firefox */
.common_rangeInput__jNn0g::-moz-range-thumb {
  cursor: pointer;

  z-index: 100;

  width: var(--thumb-size);
  height: var(--thumb-size);
  border: none;
  border-radius: 50%;

  background: var(--overlayForeground);
}

.common_rangeInput__jNn0g::-moz-focus-outer {
  border: none;
}

.common_rangeInput__jNn0g:focus-visible::-moz-range-thumb {
  outline: 2px solid var(--primaryColor);
}

.common_rangeInput__jNn0g.common_animated__NumCc::-moz-range-thumb {
  transform: scale(0);

  opacity: 0;

  -moz-transition: opacity, transform;

  transition: opacity, transform;
  transition-timing-function: ease-in-out;
  transition-duration: 0.2s;
}

.common_rangeInput__jNn0g.common_animated__NumCc:hover::-moz-range-thumb,
.common_rangeInput__jNn0g.common_animated__NumCc:focus-visible::-moz-range-thumb {
  transform: scale(1);
  opacity: 1;
}

@media (prefers-reduced-motion) {
  .common_rangeInput__jNn0g.common_animated__NumCc::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/common.module.css"],"names":[],"mappings":"AAEA;EACE,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;;EAEjB,kBAAkB;;EAElB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;;EAEZ,aAAa;EACb,cAAc;;EAEd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;;EAEX,kBAAkB;EAClB,YAAY;;EAEZ,cAAc;;EAEd,QAAQ;EACR,WAAW;;EAEX,UAAU;EACV,+BAA+B;;EAE/B,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;;EAEhB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA,gBAAgB;;AAEhB,0BAA0B;AAC1B;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,eAAe;AACjB;;AAEA,gBAAgB;;AAEhB,0BAA0B;AAC1B;EACE,eAAe;;EAEf,YAAY;;EAEZ,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;;EAElB,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;;EAEnB,UAAU;;EAEV,sCAA8B;;EAA9B,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,wBAAgB;IAAhB,gBAAgB;EAClB;AACF;;AAEA,YAAY;AACZ;EACE,eAAe;;EAEf,YAAY;;EAEZ,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;;EAElB,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;;EAEnB,UAAU;;EAEV,mCAA8B;;EAA9B,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,qBAAgB;IAAhB,gBAAgB;EAClB;AACF","sourcesContent":["@import '../fonts/fonts.module.css';\n\n:global(.player-scrollbar) {\n  scrollbar-color: var(--primaryColor) transparent;\n  scrollbar-width: thin;\n}\n\n:global(.player-scrollbar)::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n\n:global(.player-scrollbar)::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background: var(--primaryColor);\n}\n\n:global(.player-scrollbar)::-webkit-scrollbar-corner,\n:global(.player-scrollbar)::-webkit-scrollbar-track {\n  background: none;\n}\n\n.button {\n  cursor: pointer;\n  user-select: none;\n\n  position: relative;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n\n  font: inherit;\n  color: inherit;\n\n  background: none;\n  outline: none;\n}\n\n.button svg {\n  pointer-events: none;\n  color: var(--overlayForeground);\n  fill: var(--overlayForeground);\n}\n\n.button:focus-visible {\n  outline: 2px solid var(--primaryColor);\n}\n\n.button::after {\n  content: '';\n\n  position: absolute;\n  bottom: -7px;\n\n  display: block;\n\n  width: 0;\n  height: 3px;\n\n  opacity: 0;\n  background: var(--primaryColor);\n\n  transition-duration: 0.1s, 0.2s;\n  transition-property: width, opacity;\n}\n\n.button.active::after {\n  width: 100%;\n  opacity: 1;\n}\n\n.rangeInput {\n  height: var(--track-height);\n  margin: 0;\n  appearance: none;\n\n  -webkit-tap-highlight-color: transparent;\n}\n\n.rangeInput:focus {\n  outline: none;\n}\n\n/* -- Track -- */\n\n/* Chrome, Safari, Opera */\n.rangeInput::-webkit-slider-runnable-track {\n  cursor: pointer;\n  border-radius: 2px;\n}\n\n/* Firefox */\n.rangeInput::-moz-range-track {\n  cursor: pointer;\n}\n\n/* -- Thumb -- */\n\n/* Chrome, Safari, Opera */\n.rangeInput::-webkit-slider-thumb {\n  cursor: pointer;\n\n  z-index: 100;\n\n  width: var(--thumb-size);\n  height: var(--thumb-size);\n  border: none;\n  border-radius: 50%;\n\n  -webkit-appearance: none;\n  background: var(--overlayForeground);\n}\n\n.rangeInput:focus-visible::-webkit-slider-thumb {\n  outline: 2px solid var(--primaryColor);\n}\n\n.rangeInput.animated::-webkit-slider-thumb {\n  transform: scale(0);\n\n  opacity: 0;\n\n  transition: opacity, transform;\n  transition-timing-function: ease-in-out;\n  transition-duration: 0.2s;\n}\n\n.rangeInput.animated:hover::-webkit-slider-thumb {\n  transform: scale(1);\n  opacity: 1;\n}\n\n.rangeInput.animated:focus-visible::-webkit-slider-thumb {\n  transform: scale(1);\n  opacity: 1;\n}\n\n@media (prefers-reduced-motion) {\n  .rangeInput.animated::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n\n/* Firefox */\n.rangeInput::-moz-range-thumb {\n  cursor: pointer;\n\n  z-index: 100;\n\n  width: var(--thumb-size);\n  height: var(--thumb-size);\n  border: none;\n  border-radius: 50%;\n\n  background: var(--overlayForeground);\n}\n\n.rangeInput::-moz-focus-outer {\n  border: none;\n}\n\n.rangeInput:focus-visible::-moz-range-thumb {\n  outline: 2px solid var(--primaryColor);\n}\n\n.rangeInput.animated::-moz-range-thumb {\n  transform: scale(0);\n\n  opacity: 0;\n\n  transition: opacity, transform;\n  transition-timing-function: ease-in-out;\n  transition-duration: 0.2s;\n}\n\n.rangeInput.animated:hover::-moz-range-thumb,\n.rangeInput.animated:focus-visible::-moz-range-thumb {\n  transform: scale(1);\n  opacity: 1;\n}\n\n@media (prefers-reduced-motion) {\n  .rangeInput.animated::-moz-range-thumb {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `common_button__8+QIM`,
	"active": `common_active__cfwZT`,
	"rangeInput": `common_rangeInput__jNn0g`,
	"animated": `common_animated__NumCc`
};
export default ___CSS_LOADER_EXPORT___;
